'use client';

import { Languages } from 'lucide-react';
import { useLocale, useTranslations } from 'next-intl';
import { useMemo, useState } from 'react';

import { usePersistAppLocale } from '@/hooks/use-persist-app-locale';

import { LanguagePickerDialog } from '@/components/common/language-picker-dialog';
import { Button } from '@/components/ui/button';

import { type AppLocale, isAppLocale } from '@/i18n/locales';

export function LoginPageLanguageControl() {
  const tMenu = useTranslations('UserMenu');
  const localeRaw = useLocale();
  const [open, setOpen] = useState(false);
  const persistLocale = usePersistAppLocale();

  const activeLocale = useMemo(
    () => (isAppLocale(localeRaw) ? localeRaw : 'en'),
    [localeRaw],
  );

  const pickLanguage = (language: AppLocale) => {
    persistLocale.mutate(language, {
      onSuccess: () => setOpen(false),
    });
  };

  return (
    <>
      <div className='absolute end-6 top-6 z-10'>
        <Button
          type='button'
          variant='outline'
          size='sm'
          disabled={persistLocale.isPending}
          aria-label={tMenu('languageMenu')}
          onClick={() => setOpen(true)}
          className='bg-background/80 shadow-sm backdrop-blur-sm dark:bg-background/60'
        >
          <Languages className='me-2 h-4 w-4' />
          {tMenu('languageMenu')}
        </Button>
      </div>
      <LanguagePickerDialog
        open={open}
        onOpenChange={setOpen}
        activeLocale={activeLocale}
        isPending={persistLocale.isPending}
        onSelect={pickLanguage}
      />
    </>
  );
}
